module.exports = __webpack_public_path__ + "img/surgery_z6dmxf_c_scale,w_200.8f563a59.jpg";